<div class="d-flex w-100">
	<div class="d-flex flex-column w-100 mx-auto" style="max-width: 500px">
		<div class="mx-auto display-10 mt-5">
			<a href="https://focuspos.com" target="_blank">
				<img
					src="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/Focus-With-Cloud-New-Trans.png"
					style="width: 300px; height: auto"
					class="logo"
					alt="Focus POS Systems Logo"
				/>
			</a>
		</div>
		<div class="w-100 d-flex mt-5" style="max-width: 500px">
			<div class="mx-auto display-10">Sorry, the venue you're looking for can't be found.</div>
		</div>

		<div class="w-100 d-flex mt-5" style="max-width: 500px">
			<div class="mx-auto display-10">Please check your link and try again.</div>
		</div>
	</div>
</div>
